import Vue from 'vue'
import JSEncrypt from 'jsencrypt'

var cached = null

var toPem = function (base64, label) {
  var lines = base64.match(/.{1,64}/g) || []
  return '-----BEGIN ' + label + '-----\n' + lines.join('\n') + '\n-----END ' + label + '-----'
}

var parsePublicKeyData = function (res) {
  var body = res.data
  if (body.status === true && body.data) {
    return body.data
  }
  if (body.keyId && body.publicKey) {
    return body
  }
  throw new Error((body.message) || '获取公钥失败')
}

var fetchPublicKey = function (http, publicKeyPath) {
  if (cached && Date.now() < cached.expireAt) {
    return Promise.resolve(cached)
  }
  return http.get(publicKeyPath || '/common/security/public-key').then(function (res) {
    var data = parsePublicKeyData(res)
    cached = {
      keyId: data.keyId,
      publicKey: data.publicKey,
      expireAt: data.expireAt || (Date.now() + 300000)
    }
    return cached
  })
}

var encryptPlain = function (publicKey, plainPassword, timestamp, nonce) {
  var payload = JSON.stringify({
    password: plainPassword,
    timestamp: timestamp,
    nonce: nonce
  })
  var encrypt = new JSEncrypt()
  encrypt.setPublicKey(toPem(publicKey, 'PUBLIC KEY'))
  var passwordCipher = encrypt.encrypt(payload)
  if (!passwordCipher) {
    throw new Error('密码加密失败')
  }
  return passwordCipher
}

var encryptForm = function (http, form, passwordField, publicKeyPath) {
  return fetchPublicKey(http, publicKeyPath).then(function (keyInfo) {
    var timestamp = Date.now()
    var nonce = Vue.prototype.$tool.UUID()
    var body = JSON.parse(JSON.stringify(form))
    body.passwordCipher = encryptPlain(keyInfo.publicKey, form[passwordField], timestamp, nonce)
    body.keyId = keyInfo.keyId
    body.timestamp = timestamp
    body.nonce = nonce
    delete body[passwordField]
    return body
  })
}

var encryptDualPassword = function (http, form, fieldMap, publicKeyPath) {
  return fetchPublicKey(http, publicKeyPath).then(function (keyInfo) {
    var timestamp = Date.now()
    var nonce = Vue.prototype.$tool.UUID()
    var body = JSON.parse(JSON.stringify(form))
    var plainKey
    var cipherKey
    for (plainKey in fieldMap) {
      if (Object.prototype.hasOwnProperty.call(fieldMap, plainKey)) {
        cipherKey = fieldMap[plainKey]
        body[cipherKey] = encryptPlain(keyInfo.publicKey, form[plainKey], timestamp, nonce)
        delete body[plainKey]
      }
    }
    body.keyId = keyInfo.keyId
    body.timestamp = timestamp
    body.nonce = nonce
    return body
  })
}

export default function () {
  Vue.prototype.$passwordCrypto = {
    encryptForm: encryptForm,
    encryptDualPassword: encryptDualPassword
  }
}
